import React, { useState } from "react";
import { TextField, Button, Container, Typography, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { customSendPasswordResetEmail } from "../authService"; // Updated import
import Header from "../Homepage/Components/Header";
import Video from "./Login.mp4"; // Path to your video file

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState(""); // To show success/error message
  const [loading, setLoading] = useState(false); // Loading state to disable the button while sending email
  const navigate = useNavigate();

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // Call the updated function to send password reset email
      await customSendPasswordResetEmail(email);
      setMessage("Password reset email sent! Please check your inbox.");
    } catch (error) {
      setMessage("Error sending password reset email. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Header />
      <div style={{ position: "relative", height: "100vh" }}>

        
        {/* Background or Overlay (Optional) */}
        <video
          src={Video}
          type="video/mp4"
          autoPlay
          loop
          muted
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            zIndex: -1,
          }}
        />

                {/* Overlay with opacity */}
                <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 0,
          }}
        ></div>

        {/* Main Content */}
        <div
          style={{
            position: "relative",
            zIndex: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <Container
            maxWidth="xs"
            sx={{
              padding: 4,
              backgroundColor: "#fff",
              borderRadius: 2,
              boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
            }}
          >
            <Box
              component="form"
              onSubmit={handleResetPassword}
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  fontWeight: 600,
                  fontFamily: "'Work Sans', sans-serif",
                  color: "#2C3E50",
                  textAlign: "center",
                }}
              >
                Forgot Your Password?
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: "#666",
                  textAlign: "center",
                  marginBottom: "20px",
                }}
              >
                Enter your email below to receive a password reset link.
              </Typography>

              <TextField
                label="Email"
                variant="outlined"
                fullWidth
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                sx={{ backgroundColor: "#f9f9f9" }}
              />

              {message && (
                <Typography
                  variant="body2"
                  sx={{
                    color: message.includes("Error") ? "red" : "green",
                    textAlign: "center",
                    marginTop: "12px",
                  }}
                >
                  {message}
                </Typography>
              )}

              <Button
                type="submit"
                variant="contained"
                fullWidth
                disabled={loading}
                sx={{
                  backgroundColor: "#007bff",
                  color: "white",
                  fontWeight: "bold",
                  padding: "12px",
                  borderRadius: "8px",
                  textTransform: "none",
                  "&:hover": {
                    backgroundColor: "#0056b3",
                  },
                }}
              >
                {loading ? "Sending..." : "Send Reset Link"}
              </Button>

              <Button
                onClick={() => navigate("/login")}
                sx={{
                  color: "#007bff",
                  fontWeight: "bold",
                  textTransform: "none",
                  textAlign: "center",
                  marginTop: "12px",
                }}
              >
                Back to Login
              </Button>
            </Box>
          </Container>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
